import {customAxiosBE} from "../config";
import {getSessionSelectedLocation} from "../../helper/session";
import {AUTH} from "../../auth/FirebaseContext";

const PROD_HOST = "app.bussoft.rs";
const isProdHost = () => typeof window !== "undefined" && window.location.hostname === PROD_HOST;

export async function issueInvoiceApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    const pac = getSessionSelectedLocation().PAC;
    const headers = {
        'client_os': 'web',
            'client_app': 'busSoft-new',
            'client_version': '1',
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
            "PAC": pac
    }
    const endpoint = isProdHost() ? `/invoice/sale` : `/invoice/sale/test`;
    return customAxiosBE.post(endpoint, data, {
        headers: headers
    })
}

export async function issueDailyInvoiceApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    const pac = getSessionSelectedLocation().PAC;
    const headers = {
        'client_os': 'web',
        'client_app': 'busSoft-new',
        'client_version': '1',
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
        "PAC": pac
    }
    return customAxiosBE.post(`/invoice/daily-sale`, data, {
        headers: headers
    })
}

export async function issueInvoiceVerificationApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    const pac = getSessionSelectedLocation().PAC;
    const headers = {
        'client_os': 'web',
        'client_app': 'busSoft-new',
        'client_version': '1',
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
        "PAC": pac
    }
    return customAxiosBE.post(`/invoice/issueVerify`, data, {
        headers: headers
    })
}

export async function lookupVerificationApi(externalNumber) {
    return customAxiosBE.get(`/invoice/verify/lookup`, {
        params: {externalNumber}
    })
}

export async function cancelVerificationApi(externalNumber) {
    return customAxiosBE.post(`/invoice/verify/cancel`, {externalNumber})
}

export async function issueFlixInvoiceApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    const pac = getSessionSelectedLocation().PAC;
    const headers = {
        'client_os': 'web',
        'client_app': 'busSoft-new',
        'client_version': '1',
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
        "PAC": pac
    }
    return customAxiosBE.post(`/invoice/flix`, data, {
        headers: headers
    })
}

export async function issueReservationApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    const pac = getSessionSelectedLocation().PAC;
    const headers = {
        'client_os': 'web',
            'client_app': 'busSoft-new',
            'client_version': '1',
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
            "PAC": pac
    }
    return customAxiosBE.post(`/invoice/issueReservation`, data, {
        headers: headers
    })
}

export async function refundInvoiceApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    const pac = getSessionSelectedLocation().PAC;
    const headers = {
        'client_os': 'web',
        'client_app': 'busSoft-new',
        'client_version': '1',
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
        "PAC": pac
    }
    return customAxiosBE.post(`/invoice/refund`, data, {
        headers: headers
    })
}

export async function importTaxCoreInvoicesApi(data) {
    const token = await AUTH.currentUser.getIdToken(true);
    const headers = {
        'client_os': 'web',
        'client_app': 'busSoft-new',
        'client_version': '1',
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
    }
    return customAxiosBE.post(`/invoice/import`, data, {
        headers: headers
    })
}
